/* eslint-disable*/
// src/components/Sidebar.js
import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGear,
  faAngleRight,
  faCaretDown,
  faCaretRight,
  faTicket,
  faMagnifyingGlassChart,
  faChartBar,
  faChartLine,
  faUsersLine,
  faCoins,
  faLayerGroup,
  faCashRegister,
  faMoneyCheck,
  faChartDiagram,
  faUsersGear,
  faFileInvoice,
  faSliders,
  faMessage,
  faComments,
  faMoneyBillTransfer,
  faBusinessTime,
  faBriefcase,
  faHeadset,
  faShareAlt,
  faShareNodes,
  faEnvelope,
  faGraduationCap,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import "@fortawesome/fontawesome-free/css/all.min.css";
import axios from "axios";
import { NavLink, useNavigate, useLocation } from "react-router-dom"; // Use NavLink for active link functionality
import DefaultImage from "../assets/img/profile.png";
// import { jwtDecode } from "jwt-decode"; // Correct named import
import { PermissionWrapper, hasPermission } from "../helpers/permission.js"; // Adjust the import path as needed
import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css"; // Import SimpleBar CSS
import { API_URL } from "../config.js";
import { showToast } from "./toast.jsx";
import { FaMagnifyingGlassChart } from "react-icons/fa6";
import ProtectedRoute from "../helpers/ProtectedRoute";
import { ensureEmailAuth, emailApiClient, EMAIL_APIS_DISABLED } from "../email/api/client";

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [isOpenResearch, setIsOpenResearch] = useState(true);
  const [isOpenSubscriber, setIsOpenSubscriber] = useState(true);
  const [isOpenSubscription, setIsOpenSubscription] = useState(true);
  const [isOpenSettings, setIsOpenSettings] = useState(true);
  const [isOpenOrder, setIsOpenOrder] = useState(true);
  const [isOpenStreetlearn, setIsOpenStreetlearn] = useState(true);
  const [isOpenTicket, setIsOpenTicket] = useState(true);
  // const [isOpenSeo, setIsOpenSeo] = useState(true);
  // const [isOpenMobile, setIsOpenMobile] = useState(true);
  const [isOpenWorkflow, setIsOpenWorkflow] = useState(true);
  const [isOpenReport, setIsOpenReport] = useState(true);
  const [isOpenGeneral, setIsOpenGeneral] = useState(true);
  const [isOpenPayroll, setIsOpenPayroll] = useState(true);
  const [isOpenLeaveManagement, setIsOpenLeaveManagement] = useState(true);
  const [isOpenEmail, setIsOpenEmail] = useState(true);
  const location = useLocation();
  // Mailbox selected via /email?accountId=.. (NavLink's isActive ignores the query string)
  const activeEmailAccountId = ["/email", "/mail"].includes(location.pathname)
    ? new URLSearchParams(location.search).get("accountId")
    : null;
  const emailUnreadBadgeStyle = {
    flexShrink: 0,
    marginLeft: "6px",
    padding: "1px 7px",
    borderRadius: "10px",
    background: "#348fe2",
    color: "#fff",
    fontSize: "11px",
    fontWeight: 600,
    lineHeight: "16px",
  };
  const formatEmailUnread = (count) => (count > 999 ? "999+" : count);
  const [emailAccounts, setEmailAccounts] = useState([]);
  const [subscriberCounts, setSubscriberCounts] = useState({});
  const [subscriptionCounts, setSubscriptionCounts] = useState({});
  const [subscriptionPortfolioCounts, setSubscriptionPortfolioCounts] =
    useState({});
  const [userData, setUserData] = useState(null);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);
  const [tokenStatus, setTokenStatus] = useState(null);
  const [tokenLoading, setTokenLoading] = useState(true);
  const navigate = useNavigate();
  const userDataFromStorage = localStorage.getItem("user");
  const parsedUserData = userDataFromStorage
    ? JSON.parse(userDataFromStorage)
    : null;
  const toggleMenu = () => setIsOpen(!isOpen);

  // Clear all subscriber filters when clicking on main Subscriber link
  const clearSubscriberFilters = () => {
    // Clear localStorage filters
    const keys = Object.keys(localStorage).filter((key) =>
      key.startsWith("subscriber_")
    );
    keys.forEach((key) => localStorage.removeItem(key));
    sessionStorage.removeItem("subscriberFilterParams");

    // Dispatch event to clear React state filters in Subscriber component
    window.dispatchEvent(new CustomEvent('clearSubscriberFiltersEvent'));

    // Navigate to clean Subscriber page (without any filter)
    navigate("/Subscriber", { replace: true });
  };

  // const clearSubscriptionCreditsFilters = () => {
  //   const keys = Object.keys(localStorage).filter((key) =>
  //     key.startsWith("subscription_")
  //   );
  //   keys.forEach((key) => localStorage.removeItem(key));

  //   // Dispatch event to clear React state
  //   window.dispatchEvent(new CustomEvent('clearSubscriptionCreditsFiltersEvent'));

  //   // Navigate to clean URL, optionally using replace to avoid history pollution
  //   navigate("/SubscriptionCredits", { replace: true });
  // };
  const clearSubscriptionCreditsFilters = () => {
    // Remove only subscription-related keys
    const keys = Object.keys(localStorage).filter((key) =>
      key.startsWith("subscription_")
    );

    keys.forEach((key) => localStorage.removeItem(key));

    // Dispatch custom event to reset React state
    window.dispatchEvent(
      new CustomEvent("clearSubscriptionCreditsFiltersEvent")
    );

    // Navigate to clean route (no query params)
    navigate("/SubscriptionCredits", { replace: true });
  };

  const clearSubscriptionPortfolioFilters = () => {
    const keys = Object.keys(localStorage).filter((key) =>
      key.startsWith("subscriptionPortfolio_")
    );
    keys.forEach((key) => localStorage.removeItem(key));

    // Dispatch event to clear React state
    window.dispatchEvent(new CustomEvent('clearSubscriptionPortfolioFiltersEvent'));

    // Navigate to clean URL, optionally using replace to avoid history pollution
    navigate("/SubscriptionPortfolio", { replace: true });
  };
  const clearOrderFilters = () => {
    const keys = Object.keys(localStorage).filter((key) =>
      key.startsWith("order_")
    );
    keys.forEach((key) => localStorage.removeItem(key));

    // Dispatch event to clear React state
    window.dispatchEvent(new CustomEvent('clearOrderFiltersEvent'));

    navigate("/Order", { replace: true });
  };
  const clearHRMSUserManagementFilters = () => {
    const keys = Object.keys(localStorage).filter((key) =>
      key.startsWith("user_")
    );
    keys.forEach((key) => localStorage.removeItem(key));

    // Dispatch event to clear React state filters in UserManagement component
    window.dispatchEvent(new CustomEvent('clearHRMSUserManagementFiltersEvent'));

    if (window.location.pathname === "/Hrms/User" && window.location.search) {
      navigate("/Hrms/User", { replace: true });
    }
  };
  const clearHRMSDistributorUserManagementFilters = () => {
    const keys = Object.keys(localStorage).filter((key) =>
      key.startsWith("distributor_user_")
    );
    keys.forEach((key) => localStorage.removeItem(key));

    // Dispatch event to clear React state filters in DistributorUserManagement component
    window.dispatchEvent(
      new CustomEvent("clearHRMSDistributorUserManagementFiltersEvent")
    );

    if (
      window.location.pathname === "/Hrms/DistributorUser" &&
      window.location.search
    ) {
      navigate("/Hrms/DistributorUser", { replace: true });
    }
  };
  const clearResearchPerformanceFilters = () => {
    const keys = Object.keys(localStorage).filter((key) =>
      key.startsWith("performance_")
    );
    keys.forEach((key) => localStorage.removeItem(key));

    // Dispatch event to clear React state
    window.dispatchEvent(new CustomEvent('clearResearchPerformanceFiltersEvent'));

    navigate("/research/performance", { replace: true });
  };
  const clearResearchNotificationsFilters = () => {
    const keys = Object.keys(localStorage).filter((key) =>
      key.startsWith("notifications_")
    );
    keys.forEach((key) => localStorage.removeItem(key));

    // Dispatch event to clear React state
    window.dispatchEvent(new CustomEvent('clearResearchNotificationsFiltersEvent'));

    navigate("/research/notifications", { replace: true });
  };
  const clearAddNotificationForm = () => {
    // Dispatch event to clear React state
    window.dispatchEvent(new CustomEvent('clearAddNotificationFormEvent'));

    navigate("/research/notifications/add", { replace: true });
  };
  // Angel Notifications hidden - not required
  // const clearResearchAngelNotificationsFilters = () => {
  //   const keys = Object.keys(localStorage).filter((key) =>
  //     key.startsWith("angel_notifications_")
  //   );
  //   keys.forEach((key) => localStorage.removeItem(key));
  //
  //   // Dispatch event to clear React state
  //   window.dispatchEvent(new CustomEvent('clearResearchAngelNotificationsFiltersEvent'));
  //
  //   navigate("/research/angel-notifications", { replace: true });
  // };
  // const clearAddAngelNotificationForm = () => {
  //   // Dispatch event to clear React state
  //   window.dispatchEvent(new CustomEvent('clearAddAngelNotificationFormEvent'));
  //
  //   navigate("/research/angel-notifications/add", { replace: true });
  // };

  const clearOrdersSettlementsFilters = () => {
    // Dispatch event to clear React state in OrderSettlement component
    window.dispatchEvent(new CustomEvent('clearOrdersSettlementsFiltersEvent'));
    navigate("/Orders/settlements", { replace: true });
  };

  const clearSubscriptionReportFilters = () => {
    window.dispatchEvent(new CustomEvent('clearSubscriptionReportFiltersEvent'));
    navigate("/Report/Subscription", { replace: true });
  };

  const clearSubscriberStatusReportFilters = () => {
    window.dispatchEvent(new CustomEvent('clearSubscriberStatusReportFiltersEvent'));
    navigate("/Report/SubscriberStatus", { replace: true });
  };

  const clearCallSummaryReportFilters = () => {
    window.dispatchEvent(new CustomEvent('clearCallSummaryReportFiltersEvent'));
    navigate("/Report/callSummary/report", { replace: true });
  };

  const clearRevenueReportFilters = () => {
    window.dispatchEvent(new CustomEvent('clearRevenueReportFiltersEvent'));
    navigate("/Report/revenueReport", { replace: true });
  };

  const clearSubscriberAnalysisReportFilters = () => {
    window.dispatchEvent(new CustomEvent('clearSubscriberAnalysisReportFiltersEvent'));
    navigate("/Report/subscriberAnalysisReport", { replace: true });
  };

  const clearSubscriptionAnalysisReportFilters = () => {
    window.dispatchEvent(new CustomEvent('clearSubscriptionAnalysisReportFiltersEvent'));
    navigate("/Report/subscriptionAnalysisReport", { replace: true });
  };

  const clearBulkCampingReportReportFilters = () => {
    window.dispatchEvent(new CustomEvent('clearBulkCampingReportFilterEvent'));
    navigate("/Report/BulkCampaign", { replace: true });
  }
  const clearSingleCampingReportReportFilters = () => {
    window.dispatchEvent(new CustomEvent('clearSingleCampingReportFilterEvent'));
    navigate("/Report/SingleCampaign", { replace: true });
  }

  const clearBroadCastReportReportFilters = () => {
    window.dispatchEvent(new CustomEvent('clearBroadCastReportFilterEvent'));
    navigate("/Report/Broadcast", { replace: true });
  }

  const clearExecutivePerformanceReportFilters = () => {
    window.dispatchEvent(new CustomEvent('clearExecutiveReportFilterEvent'));
    navigate("/Report/ExecutivePerformance", { replace: true });
  }

  const clearEmailConfigFilters = () => {
    window.dispatchEvent(new CustomEvent('clearEmailConfigFilterEvent'));
    navigate("/Settings/EmailConfig", { replace: true });
  }
  const clearEmailMappingFilters = () => {
    window.dispatchEvent(new CustomEvent('clearEmailMappingFilterEvent'));
    navigate("/Settings/EmailMapping", { replace: true });
  }

  const clearTemplateEmailFilters = () => {
    window.dispatchEvent(new CustomEvent('clearTemplateEmailFilterEvent'));
    navigate("/Settings/TemplateEmail", { replace: true });
  }

  const clearTemplateBuilderFilters = () => {
    window.dispatchEvent(new CustomEvent('clearTemplateBuilderFilterEvent'));
    navigate("/Settings/TemplateBuilder", { replace: true });
  }

  const clearTemplatesmsFilters = () => {
    window.dispatchEvent(new CustomEvent('clearTemplatesmsFilterEvent'));
    navigate("/Settings/TemplateSms", { replace: true });
  }

  const clearTemplatePushNotificationFilters = () => {
    window.dispatchEvent(new CustomEvent('clearTemplatePushNotificationFilterEvent'));
    navigate("/Settings/TemplatePushNotification", { replace: true });
  }

  const clearTemplateWhatshappFilters = () => {
    window.dispatchEvent(new CustomEvent('clearTemplateWhatsappFilterEvent'));
    navigate("/Settings/TemplateWhatsappNotification", { replace: true });
  }

  const clearTemplateResearchFilters = () => {
    window.dispatchEvent(new CustomEvent('clearTemplateResearchFilterEvent'));
    navigate("/Settings/TemplateResearch", { replace: true });
  }

  const clearTemplateBulkCampingFilters = () => {
    window.dispatchEvent(new CustomEvent('clearTemplateBulkCampaignFilterEvent'));
    navigate("/Settings/TemplateBulkCampaign", { replace: true });
  }

  const clearInactiveRuleFilters = () => {
    window.dispatchEvent(new CustomEvent('clearInactiveRuleFilterEvent'));
    navigate("/Settings/IncentiveRule", { replace: true });
  }

  const clearLeadCreationFilters = () => {
    window.dispatchEvent(new CustomEvent('clearLeadCreationFilterEvent'));
    navigate("/Workflow/LeadCreation", { replace: true });
  }

  const clearWorkflowSubscriberFilters = () => {
    window.dispatchEvent(new CustomEvent('clearWorkFlowSubscriberFilterEvent'));
    navigate("/Workflow/Subscriber", { replace: true });
  }

  const clearWorkflowSubscriptionFilters = () => {
    window.dispatchEvent(new CustomEvent('clearWorkFlowSubscriptionFilterEvent'));
    navigate("/Workflow/Subscription", { replace: true });
  }

  const clearWorkflowOrderFilters = () => {
    window.dispatchEvent(new CustomEvent('clearWorkFlowOrderFilterEvent'));
    navigate("/Workflow/Order", { replace: true });
  }

  const clearEsiManagementFilters = () => {
    window.dispatchEvent(new CustomEvent('clearEsiManagementFiltersEvent'));
    navigate("/Hrms/EsiManagement", { replace: true });
  }

  const clearRoleManagementFilters = () => {
    window.dispatchEvent(new CustomEvent('clearRoleManagementFiltersEvent'));
    navigate("/Hrms/Role", { replace: true });
  }

  const clearLoginHistoryFilters = () => {
    window.dispatchEvent(new CustomEvent('clearLoginHistoryDateFiltersEvent'));
    navigate("/Hrms/LoginHistory", { replace: true });
  }

  const clearCategoryFilters = () => {
    window.dispatchEvent(new CustomEvent('clearCategoryFilterEvent'));
    navigate("/Ticket/Category", { replace: true });
  }

  const clearTicketFilters = () => {
    window.dispatchEvent(new CustomEvent('clearTicketFiltersEvent'));
    navigate("/Ticket/Main/tickets/1", { replace: true });
  }

  const clearDevTicketFilters = () => {
    window.dispatchEvent(new CustomEvent('clearDevTicketFiltersEvent'));
    navigate("/DevTicket/Ticket", { replace: true });
  }

  const clearServiceFilters = () => {
    window.dispatchEvent(new CustomEvent('clearServiceFilterEvent'));
    navigate("/Seo/Service", { replace: true });
  }

  const clearPageFilters = () => {
    window.dispatchEvent(new CustomEvent('clearPageFilterEvent'));
    navigate("/Seo/Page", { replace: true });
  }

  const clearServicePageFilters = () => {
    window.dispatchEvent(new CustomEvent('clearServicePageFilterEvent'));
    navigate("/Seo/ServicePages", { replace: true });
  }

  const clearCustomPageFilters = () => {
    window.dispatchEvent(new CustomEvent('clearCustomPageFilterEvent'));
    navigate("/CustomPages", { replace: true });
  }

  const clearDynamicBlogFilters = () => {
    window.dispatchEvent(new CustomEvent('clearDynamicBlogFilterEvent'));
    navigate("/DynamicBlogs", { replace: true });
  }

  const clearWebsiteSitemapFilters = () => {
    window.dispatchEvent(new CustomEvent('clearWebsiteSitemapFilterEvent'));
    navigate("/Website/Sitemap", { replace: true });
  }

  const clearWebsiteReviewsFilters = () => {
    window.dispatchEvent(new CustomEvent('clearWebsiteReviewsFilterEvent'));
    navigate("/WebsiteReviews", { replace: true });
  }

  const clearEmployeeSalaryFilters = () => {
    window.dispatchEvent(new CustomEvent('clearEmployeeSalaryFiltersEvent'));
    navigate("/Payroll/Employee/index/", { replace: true });
  }
  // Decode token and extract role details
  // const token = localStorage.getItem("authToken");
  // let roleDetails = {};  

  useEffect(() => {
    // Get user data from localStorage when component mounts
    const userDataString = localStorage.getItem("user");
    if (userDataString) {
      try {
        const parsedUserData = JSON.parse(userDataString);
        setUserData(parsedUserData);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  // Handle mobile sidebar toggle - listen for navbar-toggle button click
  useEffect(() => {
    const handleToggleClick = (e) => {
      const toggleBtn = e.target.closest('[data-click="sidebar-toggled"]');
      if (toggleBtn) {
        // Only toggle on mobile (max-width: 767px)
        const isMobile = window.innerWidth <= 767;
        if (isMobile) {
          e.preventDefault();
          e.stopPropagation();
          setIsMobileSidebarOpen((prev) => {
            const newState = !prev;
            // Toggle body class for backdrop
            if (newState) {
              document.body.classList.add("page-sidebar-toggled");
            } else {
              document.body.classList.remove("page-sidebar-toggled");
            }
            return newState;
          });
        }
      }
    };

    // Listen for clicks on toggle button
    document.addEventListener("click", handleToggleClick);

    // Close sidebar when clicking outside on mobile
    const handleClickOutside = (e) => {
      const isMobile = window.innerWidth <= 767;
      if (!isMobile || !isMobileSidebarOpen) return;

      const sidebar = document.getElementById("sidebar");
      const toggleBtn = e.target.closest('[data-click="sidebar-toggled"]');
      const backdrop = e.target.closest(".sidebar-mobile-backdrop");

      if (sidebar && !sidebar.contains(e.target) && !toggleBtn) {
        if (backdrop || !e.target.closest(".sidebar")) {
          setIsMobileSidebarOpen(false);
          document.body.classList.remove("page-sidebar-toggled");
        }
      }
    };

    document.addEventListener("click", handleClickOutside);

    // Close sidebar when resizing to desktop
    const handleResize = () => {
      if (window.innerWidth > 767 && isMobileSidebarOpen) {
        setIsMobileSidebarOpen(false);
        document.body.classList.remove("page-sidebar-toggled");
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      document.removeEventListener("click", handleToggleClick);
      document.removeEventListener("click", handleClickOutside);
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobileSidebarOpen]);

  try {
    // const decoded = token ? jwtDecode(token) : {};
    // roleDetails = decoded?.user_roledetails || {};
  } catch (err) {
    console.error("âŒ Invalid token", err);
    // roleDetails = {}; // fallback to prevent crash
  }

  // 3. Create `hasAccess` function without taking roleDetails as parameter
  // const hasAccess = (key) => {
  //   const parsed =
  //     typeof roleDetails === "string" ? JSON.parse(roleDetails) : roleDetails;
  //   // console.log("parsed Data", parsed);

  //   return parsed?.[key]?.view === "1";
  // };

  // âœ… Example usage
  // console.log("Access to dashboard:", hasAccess("dashboard"));
  // âœ… Helper function to check view access
  // const hasAccess = (key) => roleDetails?.[key]?.view === "1";

  const toggleMenuResearch = () => {
    setIsOpenResearch(!isOpenResearch);
  };
  // const toggleMenuSubscriber = () => {
  //   setIsOpenSubscriber(!isOpenSubscriber);
  // };
  // const toggleMenuSubscription = () => {
  //   setIsOpenSubscription(!isOpenSubscription);
  // };
  const toggleMenuOrder = () => {
    setIsOpenOrder(!isOpenOrder);
  };
  const toggleMenuSettings = () => {
    setIsOpenSettings(!isOpenSettings);
  };
  const toggleMenuTicket = () => {
    setIsOpenTicket(!isOpenTicket);
  };
  // const toggleMenuSeo = () => {
  //   setIsOpenSeo(!isOpenSeo);
  // };
  // const toggleMenuMobile = () => {
  //   setIsOpenMobile(!isOpenMobile);
  // };
  const toggleMenuWorkflow = () => {
    setIsOpenWorkflow(!isOpenWorkflow);
  };
  const toggleMenuReport = () => {
    setIsOpenReport(!isOpenReport);
  };
  const toggleMenuGeneral = () => {
    setIsOpenGeneral(!isOpenGeneral);
  };
  const toggleMenuPayroll = () => {
    setIsOpenPayroll(!isOpenPayroll);
  };
  const toggleMenuLeaveManagement = () => {
    setIsOpenLeaveManagement(!isOpenLeaveManagement);
  };
  const toggleMenuStreetlearn = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    setIsOpenStreetlearn(!isOpenStreetlearn);
  };

  const handleRestartPricing = async (e) => {
    e.preventDefault(); // Prevent navigation
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.get(`${API_URL}notification/check-pricing`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      // alert(
      //   response.data.message || "Live subscriptions restarted successfully"
      // );
      showToast.success(
        response.data.message || "Live subscriptions restarted successfully"
      );
    } catch (error) {
      showToast.error("Failed to restart pricing.");
    }
  };

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const response = await axios.get(
          `${API_URL}subscription/list-subscribers`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (response.data) {
          // --------------------------
          // Subscribers
          // --------------------------
          if (response.data.subscribers) {
            const counts = {};
            response.data.subscribers.items.forEach((item) => {
              counts[item.label] = item.count;
            });
            counts["Subscribers"] = response.data.subscribers.total;
            setSubscriberCounts(counts);
          }

          // --------------------------
          // Subscriptions (Credits)
          // --------------------------
          if (response.data.subscriptions) {
            const counts = {};
            response.data.subscriptions.items.forEach((item) => {
              counts[item.label] = item.count;
            });
            counts["SubscriptionCredits"] = response.data.subscriptions.total;
            setSubscriptionCounts(counts);
          }

          // --------------------------
          // Subscription Portfolio
          // --------------------------
          if (response.data.subscriptionPortfolio) {
            const counts = {};
            response.data.subscriptionPortfolio.items.forEach((item) => {
              counts[item.label] = item.count;
            });
            counts["SubscriptionPortfolio"] =
              response.data.subscriptionPortfolio.total;
            setSubscriptionPortfolioCounts(counts);
          }
        }
      } catch (error) {
        console.error("âŒ Failed to fetch counts", error);
      }
    };

    fetchCounts();
  }, []);

  // Fetch token status
  useEffect(() => {
    const fetchTokenStatus = async () => {
      try {
        setTokenLoading(true);
        const response = await axios.get(`${API_URL}common/token-status`, {
          headers: {
            Accept: '*/*'
          },
        });

        if (response.data) {
          setTokenStatus(response.data);
        }
      } catch (error) {
        console.error("Failed to fetch token status:", error);
        setTokenStatus({ status: "error" });
      } finally {
        setTokenLoading(false);
      }
    };

    fetchTokenStatus();
    // Refresh token status every 5 minutes
    const interval = setInterval(fetchTokenStatus, 5 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  // Fetch connected Email accounts for the sidebar submenu
  useEffect(() => {
    if (EMAIL_APIS_DISABLED) return;
    let isMounted = true;
    const fetchEmailAccounts = async () => {
      try {
        await ensureEmailAuth();
        const res = await emailApiClient.get('/email/accounts');
        if (isMounted && res.data && Array.isArray(res.data)) {
          setEmailAccounts(res.data);
        }
      } catch (err) {
        // Silently catch if email backend is temporarily unreachable
      }
    };

    fetchEmailAccounts();

    window.addEventListener('emailAccountsUpdated', fetchEmailAccounts);
    window.addEventListener('emailAuthReady', fetchEmailAccounts);

    return () => {
      isMounted = false;
      window.removeEventListener('emailAccountsUpdated', fetchEmailAccounts);
      window.removeEventListener('emailAuthReady', fetchEmailAccounts);
    };
  }, []);

  // Close sidebar when clicking nav links on mobile
  const handleNavLinkClick = () => {
    const isMobile = window.innerWidth <= 767;
    if (isMobile && isMobileSidebarOpen) {
      setIsMobileSidebarOpen(false);
      document.body.classList.remove("page-sidebar-toggled");
    }
  };

  const clearPortfolioFilters = () => {
    // Dispatch event to clear React state in Portfolio component
    window.dispatchEvent(new CustomEvent('clearPortfolioFiltersEvent'));
    navigate("/research/Portfolio", { replace: true });
  };

  const clearServicesFilters = () => {
    // Dispatch event to clear React state in Services component
    window.dispatchEvent(new CustomEvent('clearServicesFiltersEvent'));
    navigate("/research/Services", { replace: true });
  };

  const clearSymbolsFilters = () => {
    // Dispatch event to clear React state in Symbol component
    window.dispatchEvent(new CustomEvent('clearSymbolsFiltersEvent'));
    navigate("/research/Symbol", { replace: true });
  };

  const clearSegmentFilters = () => {
    // Dispatch event to clear React state in Segment component
    window.dispatchEvent(new CustomEvent('clearSegmentFiltersEvent'));
    navigate("/research/segment", { replace: true });
  };

  const clearStreetViewFilters = () => {
    // Dispatch event to clear React state in StreetView component
    window.dispatchEvent(new CustomEvent('clearStreetViewFiltersEvent'));
    navigate("/research/StreetView", { replace: true });
  };

  const clearPushNotificationFilters = () => {
    window.dispatchEvent(new CustomEvent('clearPushNotificationFiltersEvent'));
    navigate("/Campaign/PushNotification", { replace: true });
  };

  const clearFolioPushNotificationFilters = () => {
    window.dispatchEvent(new CustomEvent('clearFolioPushNotificationFiltersEvent'));
    navigate("/Campaign/FolioPushNotification", { replace: true });
  };

  const clearSocialSharingFilters = () => {
    window.dispatchEvent(new CustomEvent('clearSocialSharingFiltersEvent'));
    navigate("/research/SocialSharing", { replace: true });
  };

  const clearWhatsappFilters = () => {
    window.dispatchEvent(new CustomEvent('clearWhatsappFiltersEvent'));
    navigate("/research/whatsapp", { replace: true });
  };

  const clearEmailFilters = () => {
    window.dispatchEvent(new CustomEvent('clearEmailFiltersEvent'));
    navigate("/research/SendMail", { replace: true });
  };

  const clearNotificationHistoryFilters = () => {
    window.dispatchEvent(new CustomEvent('clearNotificationHistoryFiltersEvent'));
    navigate("/Research/NotificationHistory", { replace: true });
  };


  return (
    <>
      {/* Mobile Backdrop - only shown on mobile when sidebar is open */}
      {isMobileSidebarOpen && window.innerWidth <= 767 && (
        <div
          className="sidebar-mobile-backdrop"
          onClick={() => {
            setIsMobileSidebarOpen(false);
            document.body.classList.remove("page-sidebar-toggled");
          }}
        />
      )}
      <div
        id="sidebar"
        className={`sidebar with-shadow mt-3 ${isMobileSidebarOpen ? "sidebar-mobile-open" : ""
          }`}
      >
        <div
          data-scrollbar="true"
          className="slimScrollDiv"
          style={{
            position: "relative",
            overflow: "hidden",
            width: "12.375rem",
            height: "100%",
          }}
        >
          <div
            // style={{
            //   width: "12.375rem",
            //   height: "100vh",
            //   position: "fixed",
            //   top: 40,
            //   left: 0,
            //   borderRight: "1px solid #e6e6e6",
            //   boxShadow: "0 0.125rem 2.5rem 0 rgba(0, 0, 0, 0.08) !important",
            //   backgroundColor: "#fff",
            // }}
            style={{
              width: window.innerWidth <= 767 ? "27.375rem" : "12.375rem",
              height: "100vh",
              position: "fixed",
              top: 40,
              left: 0,
              borderRight: "1px solid #e6e6e6",
              boxShadow: "0 0.125rem 2.5rem 0 rgba(0, 0, 0, 0.08)",
              backgroundColor: "#fff",
              zIndex: 1020,
              transition: "left 0.3s ease",
            }}
            className="responsive-sidebar"
          >
            {/* Mobile Close Button - Top Right */}
            {/* <button
              onClick={() => {
                setIsMobileSidebarOpen(false);
                document.body.classList.remove('page-sidebar-toggled');
              }}
              className="sidebar-mobile-close-btn"
              aria-label="Close sidebar"
            >
              Ã—
            </button> */}
            <SimpleBar style={{ maxHeight: "95%" }} autoHide={true}>
              <ul
                className="nav"
                onClick={(e) => {
                  // Close sidebar on mobile when clicking navigation links
                  const link = e.target.closest("a");
                  if (link && isMobileSidebarOpen) {
                    const isMobile = window.innerWidth <= 767;
                    if (isMobile) {
                      const href = link.getAttribute("href");
                      // Close for internal navigation links but not dropdown toggles
                      if (
                        href &&
                        href.startsWith("/") &&
                        href !== "#" &&
                        !href.startsWith("http") &&
                        !href.includes("kite.zerodha.com")
                      ) {
                        handleNavLinkClick();
                      }
                    }
                  }
                }}
              >
                <li className="nav-profile">
                  <div className="image">
                    <img
                      src={parsedUserData?.user_image || DefaultImage}
                      alt="Profile"
                      onError={(e) => {
                        e.target.src = DefaultImage;
                      }}
                    />
                  </div>
                  <div className="info">
                    <h4>{userData ? userData.user_fullname : "Loading..."}</h4>
                    <p>{userData ? userData.user_designation : "Loading..."}</p>
                    <p>
                      EmpID : {userData ? userData.user_code : "Loading..."}
                    </p>
                  </div>
                </li>
                <li className="nav-divider"></li>
                {/* --- DROPDOWN START --- */}
                <PermissionWrapper module="dashboardpersonal" action="view">
                  <li style={{ padding: "10px" }}>
                    <SidebarDropdown navigate={navigate} />
                  </li>
                </PermissionWrapper>
                {/* --- DROPDOWN END --- */}
                <li className="nav-header">Menu</li>
                <PermissionWrapper module="gentoken" action="view">
                  <li>
                    <a
                      href="https://kite.zerodha.com/connect/login?v=3&api_key=cnq5mgdmle9l5w9j"
                      className="nav-link"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="d-flex align-items-center justify-content-between">

                        {/* Left Side: Icon + Text */}
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon
                            icon={faTicket}
                            style={{ fontSize: "18px", color: "#453e3e" }}
                            className="me-2"
                          />
                          <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                            Generate Token
                          </span>
                        </div>

                        {/* Right Side: Time / Pending */}
                        {!tokenLoading && tokenStatus && (
                          <span style={{ fontSize: "11px", fontWeight: "500", marginTop: "4px" }}>
                            {tokenStatus.loginTime ? (
                              <span style={{ color: "#28a745" }}>
                                {tokenStatus.loginTime.split(" ")[1]}
                              </span>
                            ) : (
                              <span style={{ color: "#dc3545" }}>
                                Pending
                              </span>
                            )}
                          </span>
                        )}

                      </div>
                    </a>
                  </li>

                  <li>
                    <NavLink
                      to="/dashboard"
                      className={({ isActive }) =>
                        isActive ? "active" : "nav-link"
                      }
                      onClick={handleRestartPricing}
                    >
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faShareNodes}
                          style={{ fontSize: "18px", color: "#453e3e" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Restart Pricing
                      </span>
                    </NavLink>
                  </li>
                </PermissionWrapper>
                <li className="nav-header">Navigation</li>
                <PermissionWrapper module="dashboard" action="view">
                  <li>
                    <NavLink
                      to="/dashboard"
                      className={({ isActive }) =>
                        isActive ? "active" : "nav-link"
                      }
                    >
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faBriefcase}
                          style={{ fontSize: "18px", color: "#453e3e" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Dashboard
                      </span>
                    </NavLink>
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="distributor_dashboard" action="view">
                  <li>
                    <NavLink
                      to="/distributor-dashboard"
                      className={({ isActive }) =>
                        isActive ? "active" : "nav-link"
                      }
                    >
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faCoins}
                          style={{ fontSize: "18px", color: "#453e3e" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Distributor
                      </span>
                    </NavLink>
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="dashboardpersonal" action="view">
                  <li>
                    <NavLink
                      to="/my-dashboard"
                      className={({ isActive }) =>
                        isActive ? "active" : "nav-link"
                      }
                    >
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faBusinessTime}
                          style={{ fontSize: "18px", color: "#453e3e" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        My Dashboard
                      </span>
                    </NavLink>
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="AnalysisDashboard" action="view">
                  <li>
                    <NavLink
                      to="/AnalysisDashboard"
                      className={({ isActive }) =>
                        isActive ? "active" : "nav-link"
                      }
                    >
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faChartLine}
                          style={{ fontSize: "18px", color: "#453e3e" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Analysis Dashboard
                      </span>
                    </NavLink>
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="sales_analysis_dashboard" action="view">
                  <li>
                    <NavLink
                      to="/SalesAnalysisDashboard"
                      className={({ isActive }) =>
                        isActive ? "active" : "nav-link"
                      }
                    >
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faChartBar}
                          style={{ fontSize: "18px", color: "#453e3e" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Sales Analytics
                      </span>
                    </NavLink>
                  </li>
                </PermissionWrapper>

                <PermissionWrapper module="research" action="view">
                  <li>
                    <NavLink
                      to="#"
                      onClick={toggleMenuResearch}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpen ? faCaretDown : faCaretRight}
                        className="pull-right"
                        style={{ marginLeft: "8px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FaMagnifyingGlassChart
                          style={{
                            color: "#453e3e",
                            fontSize: "18px",
                            // fontWeight: "bold"
                          }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Research
                      </span>
                    </NavLink>
                    {isOpenResearch && (
                      <ul className="sub-menu">
                        <PermissionWrapper module="markets" action="view">
                          {/* <li>
                          <NavLink
                            to="/research/markets"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Markets</span>
                          </NavLink>
                        </li> */}
                        </PermissionWrapper>
                        <PermissionWrapper module="notification" action="view">
                          <PermissionWrapper module="notification" action="add">
                            <li>
                              <NavLink
                                to="/research/notifications/add"
                                onClick={clearAddNotificationForm}
                                className={({ isActive }) =>
                                  isActive ? "active" : ""
                                }
                              >
                                <FontAwesomeIcon icon={faAngleRight} />
                                <span> Add Notifications</span>
                              </NavLink>
                            </li>
                          </PermissionWrapper>
                        </PermissionWrapper>
                        <PermissionWrapper module="notification" action="view">
                          <li>
                            <NavLink
                              to="/research/notifications"
                              onClick={clearResearchNotificationsFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Notifications</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        {/* Angel Notifications hidden - not required
                        <PermissionWrapper module="angel_notification" action="view">
                          <PermissionWrapper module="angel_notification" action="add">
                            <li>
                              <NavLink
                                to="/research/angel-notifications/add"
                                onClick={clearAddAngelNotificationForm}
                                className={({ isActive }) =>
                                  isActive ? "active" : ""
                                }
                              >
                                <FontAwesomeIcon icon={faAngleRight} />
                                <span> Add Angel Notifications</span>
                              </NavLink>
                            </li>
                          </PermissionWrapper>
                        </PermissionWrapper>
                        <PermissionWrapper module="angel_notification" action="view">
                          <li>
                            <NavLink
                              to="/research/angel-notifications"
                              onClick={clearResearchAngelNotificationsFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Angel Notifications</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        */}
                        <PermissionWrapper module="notification" action="view">
                          <li>
                            <NavLink
                              to="/research/markets/hourly/report"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Market Hourly Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="notification" action="view">
                          <li>
                            <NavLink
                              to="/research/markets/hourly/commentary"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Hourly Commentary</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="performance" action="view">
                          <li>
                            <NavLink
                              to="/research/performance"
                              onClick={clearResearchPerformanceFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Research Calls</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>

                        <PermissionWrapper module="portfolio" action="view">
                          <li>
                            <NavLink
                              to="/research/Portfolio"
                              onClick={clearPortfolioFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Portfolio</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="services" action="view">
                          <li>
                            <NavLink
                              to="/research/Services"
                              onClick={clearServicesFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Services</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="services" action="view">
                          <li>
                            <NavLink
                              to="/research/segment"
                              onClick={clearSegmentFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Segment</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="symbols" action="view">
                          <li>
                            <NavLink
                              to="/research/Symbol"
                              onClick={clearSymbolsFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Symbol</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="streetview" action="view">
                          <li>
                            <NavLink
                              to="/research/StreetView"
                              onClick={clearStreetViewFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> StreetView</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_templatebuilder"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/TemplateBuilder"
                              onClick={clearTemplateBuilderFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Streetview Builder</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_product_subscriptions"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/research/ProductSubscriptions"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Product Subscriptions</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="analystView" action="view">
                          <li>
                            <NavLink
                              to="/research/analystView"
                              // onClick={clearAnalystViewFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Analyst View</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="pushnotifications"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Campaign/PushNotification"
                              onClick={clearPushNotificationFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Push Notifications SG</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="folio_pushnotifications"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Campaign/FolioPushNotification/sf"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Push Notifications SF</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="folio_pushnotifications"
                          action="view"
                        >
                        </PermissionWrapper>
                        <PermissionWrapper module="socialsharing" action="view">
                          <li>
                            <NavLink
                              to="/research/SocialSharing"
                              onClick={clearSocialSharingFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Social Sharing</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="campaign_whatsapp"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/research/whatsapp"
                              onClick={clearWhatsappFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Whatsapp</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="campaign_email"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/research/SendMail"
                              onClick={clearEmailFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Email</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="chat_sg" action="view">
                          <li>
                            <NavLink
                              to="/research/sg-messages"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                              style={{ color: "#007bff" }}
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span style={{ color: "#007bff" }}> SG Messages</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="chat_sf" action="view">
                          <li>
                            <NavLink
                              to="/research/sf-messages"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                              style={{ color: "#d4af37" }}
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span style={{ color: "#d4af37" }}> SF Messages</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="patterns_radar" action="view">
                          <li>
                            <NavLink
                              to="/research/patterns-radar"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Street Analysis</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="careparva_report" action="view">
                          <li>
                            <NavLink
                              to="/research/careparva-report"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Careparva Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="careparrva_output" action="view">
                          <li>
                            <NavLink
                              to="/research/careparrva-output"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Careparrva Output</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                      </ul>
                    )}
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="notificationhistory" action="view">
                  <li>
                    <NavLink
                      to="/Research/NotificationHistory"
                      onClick={clearNotificationHistoryFilters}
                      className={({ isActive }) =>
                        isActive ? "active" : "nav-link"
                      }
                    >
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faChartBar}
                          style={{ fontSize: "18px", color: "#453e3e" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Research History
                      </span>
                    </NavLink>
                  </li>
                </PermissionWrapper>

                <PermissionWrapper module="subscriber" action="view">
                  <li>
                    <NavLink
                      to="/Subscriber"
                      onClick={clearSubscriberFilters}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpenSubscriber ? faCaretDown : faCaretRight}
                        className="pull-right"
                        style={{ marginLeft: "4px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faUsersLine}
                          style={{ fontSize: "18px", color: "#453e3e" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        Subscriber{" "}
                        {subscriberCounts["Subscribers"] !== undefined &&
                          `(${subscriberCounts["Subscribers"]})`}
                      </span>
                    </NavLink>
                    {isOpenSubscriber && (
                      <ul className="sub-menu">
                        {/* <li>
                          <NavLink
                            to={"/Subscriber?filter=Read"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Read{" "}
                              {subscriberCounts["Read"] !== undefined &&
                                `(${subscriberCounts["Read"]})`}
                            </span>
                          </NavLink>
                        </li> */}
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=RecentContacted"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Recent Leads{" "}
                              {subscriberCounts["Recent Contacted"] !==
                                undefined &&
                                `(${subscriberCounts["Recent Contacted"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=Unread"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Unread{" "}
                              {subscriberCounts["Unread"] !== undefined &&
                                `(${subscriberCounts["Unread"]})`}
                            </span>
                          </NavLink>
                        </li>
                        {/* <li>
                          <NavLink
                            to={"/Subscriber?filter=RecentSubscriber"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Recent Subscribers{" "}
                              {subscriberCounts["Recent Subscribers"] !==
                                undefined &&
                                `(${subscriberCounts["Recent Subscribers"]})`}
                            </span>
                          </NavLink>
                        </li> */}
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=New"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              New{" "}
                              {subscriberCounts["New"] !== undefined &&
                                `(${subscriberCounts["New"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=Hot"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              <span className="badge bg-success">
                                Hot
                                {subscriberCounts["Hot"] !== undefined &&
                                  ` (${subscriberCounts["Hot"]})`}
                              </span>
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=Warm"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              <span className="badge bg-warning text-dark">
                                Warm
                                {subscriberCounts["Warm"] !== undefined &&
                                  ` (${subscriberCounts["Warm"]})`}
                              </span>
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=Value"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              <span className="badge bg-primary">
                                Value
                                {subscriberCounts["Value"] !== undefined &&
                                  ` (${subscriberCounts["Value"]})`}
                              </span>
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=Escalate"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              <span className="badge bg-danger">
                                Escalate
                                {subscriberCounts["Escalate"] !== undefined &&
                                  ` (${subscriberCounts["Escalate"]})`}
                              </span>
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=Opened"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Opened{" "}
                              {subscriberCounts["Opened"] !== undefined &&
                                `(${subscriberCounts["Opened"]})`}
                            </span>
                          </NavLink>
                        </li>

                        <li>
                          <NavLink
                            to={"/Subscriber?filter=Opened3Times"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Opened 3 Times{" "}
                              {subscriberCounts["Opened 3 Times"] !== undefined &&
                                `(${subscriberCounts["Opened 3 Times"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=Opened5Times"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Opened 5 Times{" "}
                              {subscriberCounts["Opened 5 Times"] !== undefined &&
                                `(${subscriberCounts["Opened 5 Times"]})`}
                            </span>
                          </NavLink>
                        </li>
                        
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=Followup"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Followup{" "}
                              {subscriberCounts["Followup"] !== undefined &&
                                `(${subscriberCounts["Followup"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=FollowupToday"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Followup Today{" "}
                              {subscriberCounts["Followup Today"] !== undefined &&
                                `(${subscriberCounts["Followup Today"]})`}
                            </span>
                          </NavLink>
                        </li>

                        {/* <li>
                          <NavLink
                            to={"/Subscriber?filter=ContactToday"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Contact Today{" "}
                              {subscriberCounts["Contact Today"] !==
                                undefined &&
                                `(${subscriberCounts["Contact Today"]})`}
                            </span>
                          </NavLink>
                        </li> */}
                        {/* <li>
                          <NavLink
                            to={"/Subscriber?filter=FutureContact"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Future Contact{" "}
                              {subscriberCounts["Future Contacts"] !==
                                undefined &&
                                `(${subscriberCounts["Future Contacts"]})`}
                            </span>
                          </NavLink>
                        </li> */}
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=NotInterested"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Not Interested{" "}
                              {subscriberCounts["Not Interested"] !==
                                undefined &&
                                `(${subscriberCounts["Not Interested"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=NoResponse"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              No Response{" "}
                              {subscriberCounts["No Response"] !== undefined &&
                                `(${subscriberCounts["No Response"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=Prospect"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Prospect{" "}
                              {subscriberCounts["Prospect"] !== undefined &&
                                `(${subscriberCounts["Prospect"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=ProspectLost"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Prospect Lost{" "}
                              {subscriberCounts["Prospect Lost"] !== undefined &&
                                `(${subscriberCounts["Prospect Lost"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=Subscribed"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Subscribed{" "}
                              {subscriberCounts["Subscribed"] !== undefined &&
                                `(${subscriberCounts["Subscribed"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/Subscriber?filter=Junk"}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Junk{" "}
                              {subscriberCounts["Junk"] !== undefined &&
                                `(${subscriberCounts["Junk"]})`}
                            </span>
                          </NavLink>
                        </li>
                        
                        {/* {hasAccess("report_callsummary") && ( */}
                        <li>
                          <NavLink
                            to="/Report/callSummary"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Incoming Call Report{" "}
                              {subscriberCounts["Incoming Call Report"] !==
                                undefined &&
                                `(${subscriberCounts["Incoming Call Report"]})`}
                            </span>
                          </NavLink>
                        </li>
                        {/* )} */}
                        <PermissionWrapper module="subscriber_portfolio" action="view">
                          <li>
                            <NavLink
                              to="/SubscriberPortfolio"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Subscriber Portfolio</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                      </ul>
                    )}
                  </li>
                </PermissionWrapper>

                {/* <PermissionWrapper module="subscription" action="view">
                <li>
                  <NavLink
                    to="/Subscription"
                    // onClick={toggleMenuSubscription}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon
                      icon={isOpen ? faCaretDown : faCaretRight}
                      className="pull-right"
                      style={{ marginLeft: "8px" }}
                    />
                    <FontAwesomeIcon icon={faGear} />
                    <span> Subscription</span>
                  </NavLink>
                  {isOpenSubscription && (
                    <ul className="sub-menu">
                      <li>
                        <NavLink
                          to="/Subscription"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Free</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Subscription"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Free Active</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Subscription"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Expired Today</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Subscription"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Free Expired</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Subscription"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Performance</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Subscription"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Paid</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Subscription"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Paid Active</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Subscription"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Paid InProgress</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Subscription"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Paid Expired</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Subscription"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Duplicates</span>
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/Subscription"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Pending Approval</span>
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
              </PermissionWrapper> */}
                <PermissionWrapper module="subscription" action="view">
                  <li>
                    <NavLink
                      to="/SubscriptionCredits"
                      // onClick={toggleMenuSubscription}
                      onClick={clearSubscriptionCreditsFilters}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpen ? faCaretDown : faCaretRight}
                        className="pull-right"
                        style={{ marginLeft: "5px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faCoins}
                          style={{ color: "#453e3e", fontSize: "18px" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        Trade Calls{" "}
                        {subscriptionCounts["SubscriptionCredits"] !==
                          undefined &&
                          `(${subscriptionCounts["SubscriptionCredits"]})`}
                      </span>
                    </NavLink>
                    {isOpenSubscription && (
                      <ul className="sub-menu">
                        <li>
                          <NavLink
                            to="/SubscriptionCredits?filter=Free"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Free{" "}
                              {subscriptionCounts["Free"] !== undefined &&
                                `(${subscriptionCounts["Free"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/SubscriptionCredits?filter=FreeActive"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Free Active{" "}
                              {subscriptionCounts["Free Active"] !==
                                undefined &&
                                `(${subscriptionCounts["Free Active"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/SubscriptionCredits?filter=ExpiredToday"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Expired Today{" "}
                              {subscriptionCounts["Expired Today"] !==
                                undefined &&
                                `(${subscriptionCounts["Expired Today"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/SubscriptionCredits?filter=FreeExpired"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Free Expired{" "}
                              {subscriptionCounts["Free Expired"] !==
                                undefined &&
                                `(${subscriptionCounts["Free Expired"]})`}
                            </span>
                          </NavLink>
                        </li>
                        {/* <li>
                        <NavLink
                          to="/SubscriptionCredits"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Performance</span>
                        </NavLink>
                      </li> */}
                        <li>
                          <NavLink
                            to="/SubscriptionCredits?filter=Paid"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Paid{" "}
                              {subscriptionCounts["Paid"] !== undefined &&
                                `(${subscriptionCounts["Paid"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/SubscriptionCredits?filter=PaidActive"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Paid Active{" "}
                              {subscriptionCounts["Paid Active"] !==
                                undefined &&
                                `(${subscriptionCounts["Paid Active"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/SubscriptionCredits?filter=PaidInProgress"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Paid InProgress{" "}
                              {subscriptionCounts["Paid InProgress"] !==
                                undefined &&
                                `(${subscriptionCounts["Paid InProgress"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/SubscriptionCredits?filter=PaidExpired"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Paid Expired{" "}
                              {subscriptionCounts["Paid Expired"] !==
                                undefined &&
                                `(${subscriptionCounts["Paid Expired"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/SubscriptionCredits?filter=Duplicated"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Duplicates{" "}
                              {subscriptionCounts["Duplicates"] !== undefined &&
                                `(${subscriptionCounts["Duplicates"]})`}
                            </span>
                          </NavLink>
                        </li>
                        {/* <li>
                        <NavLink
                          to="/SubscriptionCredits"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Pending Approval</span>
                        </NavLink>
                      </li> */}
                      </ul>
                    )}
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="subscription" action="view">
                  <li>
                    <NavLink
                      to="/SubscriptionPortfolio"
                      // onClick={toggleMenuSubscription}
                      onClick={clearSubscriptionPortfolioFilters}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpen ? faCaretDown : faCaretRight}
                        className="pull-right"
                      // style={{ marginLeft: "2px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faLayerGroup}
                          style={{ color: "#453e3e", fontSize: "18px" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        Portfolios{" "}
                        {subscriptionPortfolioCounts[
                          "SubscriptionPortfolio"
                        ] !== undefined &&
                          `(${subscriptionPortfolioCounts["SubscriptionPortfolio"]})`}
                      </span>
                    </NavLink>
                    {isOpenSubscription && (
                      <ul className="sub-menu">
                        {/* <li>
                        <NavLink
                          to="/SubscriptionPortfolio?filter=Free"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span>
                            Free{" "}
                            {subscriptionPortfolioCounts["Free"] !==
                              undefined &&
                              `(${subscriptionPortfolioCounts["Free"]})`}
                          </span>
                        </NavLink>
                      </li> */}
                        {/* <li>
                        <NavLink
                          to="/SubscriptionPortfolio?filter=FreeActive"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span>
                            Free Active{" "}
                            {subscriptionPortfolioCounts["Free Active"] !==
                              undefined &&
                              `(${subscriptionPortfolioCounts["Free Active"]})`}
                          </span>
                        </NavLink>
                      </li> */}
                        <li>
                          <NavLink
                            to="/SubscriptionPortfolio?filter=Paid"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Paid{" "}
                              {subscriptionPortfolioCounts["Paid"] !==
                                undefined &&
                                `(${subscriptionPortfolioCounts["Paid"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/SubscriptionPortfolio?filter=PaidActive"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Paid Active{" "}
                              {subscriptionPortfolioCounts["Paid Active"] !==
                                undefined &&
                                `(${subscriptionPortfolioCounts["Paid Active"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/SubscriptionPortfolio?filter=PaidExpired"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Paid Expired{" "}
                              {subscriptionPortfolioCounts["Paid Expired"] !==
                                undefined &&
                                `(${subscriptionPortfolioCounts["Paid Expired"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/SubscriptionPortfolio?filter=ExpiredToday"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Expired Today{" "}
                              {subscriptionPortfolioCounts["Expired Today"] !==
                                undefined &&
                                `(${subscriptionPortfolioCounts["Expired Today"]})`}
                            </span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/SubscriptionPortfolio?filter=Renewed"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>
                              Renewed{" "}
                              {subscriptionPortfolioCounts["Renewed"] !==
                                undefined &&
                                `(${subscriptionPortfolioCounts["Renewed"]})`}
                            </span>
                          </NavLink>
                        </li>
                        {/* <li>
                        <NavLink
                          to="/SubscriptionPortfolio?filter=FreeExpired"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span>
                            Free Expired{" "}
                            {subscriptionPortfolioCounts["Free Expired"] !==
                              undefined &&
                              `(${subscriptionPortfolioCounts["Free Expired"]})`}
                          </span>
                        </NavLink>
                      </li> */}
                        {/* <li>
                        <NavLink
                          to="/SubscriptionPortfolio"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Performance</span>
                        </NavLink>
                      </li> */}
                        {/* <li>
                        <NavLink
                          to="/SubscriptionPortfolio?filter=PaidInProgress"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Paid InProgress</span>
                        </NavLink>
                      </li> */}
                        {/* <li>
                        <NavLink
                          to="/SubscriptionPortfolio"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span>
                            Duplicates{" "}
                            {subscriptionPortfolioCounts["Duplicates"] !==
                              undefined &&
                              `(${subscriptionPortfolioCounts["Duplicates"]})`}
                          </span>
                        </NavLink>
                      </li> */}
                        {/* <li>
                        <NavLink
                          to="/SubscriptionPortfolio"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Pending Approval</span>
                        </NavLink>
                      </li> */}
                      </ul>
                    )}
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="orders" action="view">
                  <li>
                    <NavLink
                      to="/Order"
                      // onClick={toggleMenuOrder}
                      onClick={clearOrderFilters}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpen ? faCaretDown : faCaretRight}
                        className="pull-right"
                        style={{ marginLeft: "8px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faCashRegister}
                          style={{ color: "#453e3e", fontSize: "18px" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Orders
                      </span>
                    </NavLink>
                    {isOpenOrder && (
                      <ul className="sub-menu">
                        <li>
                          <NavLink
                            to="/Order?filter=Pending"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Pending</span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/Order?filter=Approved"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Approved</span>
                          </NavLink>
                        </li>
                      </ul>
                    )}
                  </li>
                  <PermissionWrapper module="orders_settlements" action="view">
                    <li>
                      <NavLink
                        to="/Orders/settlements"
                        onClick={clearOrdersSettlementsFilters}
                        className={({ isActive }) =>
                          isActive ? "active" : "nav-link"
                        }
                      >
                        <span style={{ fontWeight: "bold" }}>
                          <FontAwesomeIcon
                            icon={faMoneyCheck}
                            style={{ color: "#453e3e", fontSize: "18px" }}
                          />
                        </span>
                        <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                          {" "}
                          Orders Settlements
                        </span>
                      </NavLink>
                    </li>
                  </PermissionWrapper>
                </PermissionWrapper>

                {/* Email Module  */}
                {/* <PermissionWrapper module="email" action="view">
                  <li>
                    <NavLink
                      to="/email"
                      onClick={(e) => {
                        if (emailAccounts && emailAccounts.length > 0) {
                          setIsOpenEmail(!isOpenEmail);
                        }
                      }}
                      className={({ isActive }) =>
                        isActive ? "active" : "nav-link"
                      }
                    >
                      {emailAccounts && emailAccounts.length > 0 && (
                        <FontAwesomeIcon
                          icon={isOpenEmail ? faCaretDown : faCaretRight}
                          className="pull-right"
                          style={{ marginLeft: "4px" }}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setIsOpenEmail(!isOpenEmail);
                          }}
                        />
                      )}
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          style={{ fontSize: "18px", color: "#453e3e" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Email
                      </span>
                     
                      {!(isOpenEmail && emailAccounts.length > 0) &&
                        emailAccounts.reduce(
                          (sum, a) => sum + (a.counts?.unread ?? 0),
                          0
                        ) > 0 && (
                          <span style={emailUnreadBadgeStyle}>
                            {formatEmailUnread(
                              emailAccounts.reduce(
                                (sum, a) => sum + (a.counts?.unread ?? 0),
                                0
                              )
                            )}
                          </span>
                        )}
                    </NavLink>
                    {isOpenEmail && emailAccounts && emailAccounts.length > 0 && (
                      <ul className="sub-menu">
                        {emailAccounts.map((acct) => (
                          <li key={acct.id}>
                            <NavLink
                              to={`/email?accountId=${acct.id}`}
                              className={() =>
                                String(acct.id) === String(activeEmailAccountId)
                                  ? "active"
                                  : ""
                              }
                              title={
                                (acct.counts?.unread ?? 0) > 0
                                  ? `${acct.emailAddress} â€” ${acct.counts.unread} unread`
                                  : acct.emailAddress
                              }
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <FontAwesomeIcon
                                icon={faAngleRight}
                                style={{ flexShrink: 0, marginRight: "5px" }}
                              />
                              <span
                                style={{
                                  flex: 1,
                                  minWidth: 0,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {acct.emailAddress
                                  ? acct.emailAddress.length > 7
                                    ? `${acct.emailAddress.slice(0, 7)}...`
                                    : acct.emailAddress
                                  : ""}
                                {(acct.counts?.all ?? 0) > 0 &&
                                  ` (${acct.counts?.all ?? 0})`}
                              </span>
                              {(acct.counts?.unread ?? 0) > 0 && (
                                <span style={emailUnreadBadgeStyle}>
                                  {formatEmailUnread(acct.counts.unread)}
                                </span>
                              )}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                </PermissionWrapper> */}
                <PermissionWrapper module="settings" action="view">
                  <li>
                    <NavLink
                      to="#"
                      onClick={toggleMenuSettings}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpen ? faCaretDown : faCaretRight}
                        className="pull-right"
                        style={{ marginLeft: "8px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faGear}
                          style={{ color: "#453e3e", fontSize: "18px" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Settings
                      </span>
                    </NavLink>
                    {isOpenSettings && (
                      <ul className="sub-menu">
                        <PermissionWrapper
                          module="settings_company"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/Company"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Company Info</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_company"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/AiCallingPrompts"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> AI Prompts</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_emailconfig"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/EmailConfig"
                              onClick={clearEmailConfigFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Email Configurations</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_mapping"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/EmailMapping"
                              onClick={clearEmailMappingFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Email Mapping</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        {/* <PermissionWrapper module="settings_letter" action="view">
                        <li>
                          <NavLink
                            to="/Settings/TemplateLetter"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Template Letter</span>
                          </NavLink>
                        </li>
                      </PermissionWrapper> */}
                        <PermissionWrapper
                          module="settings_email"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/TemplateEmail"
                              onClick={clearTemplateEmailFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Template Email</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="settings_sms" action="view">
                          <li>
                            <NavLink
                              to="/Settings/TemplateSms"
                              onClick={clearTemplatesmsFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Template SMS</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        {/* <li>
                        <NavLink
                          to="/Settings/TemplatePortfolio"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Template Portfolio</span>
                        </NavLink>
                      </li> */}
                        <PermissionWrapper
                          module="settings_pushnotification"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/TemplatePushNotification"
                              onClick={clearTemplatePushNotificationFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Template Push Notification</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_whatsappnotification"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/TemplateWhatsappNotification"
                              onClick={clearTemplateWhatshappFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Template Whatsapp</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_researchsms"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/TemplateResearch"
                              onClick={clearTemplateResearchFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Template Research</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_media_upload"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/MediaUpload"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Media Upload</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_bulkCampaign"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/TemplateBulkCampaign"
                              onClick={clearTemplateBulkCampingFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Template Bulk Campaign </span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_pickuplist"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/Pickuplist/crm"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Pickup List </span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_investorcharter"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/InvestorCharter"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Investor Charter </span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_incentiverule"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/IncentiveRule"
                              onClick={clearInactiveRuleFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Incentive Rule </span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="settings_configurations_templates"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Settings/ConfigurationsTemplates"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Configurations Templates </span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <li>
                          <NavLink
                            to="/Settings/apiconfig"
                            // onClick={clearInactiveRuleFilters}
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> BotSense Config </span>
                          </NavLink>
                        </li>
                        <PermissionWrapper module="utm_links" action="view">
                          <li>
                            <NavLink
                              to="/utm-links"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> UTM Links </span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        {/* </PermissionWrapper> */}
                      </ul>
                    )}
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="workflow" action="view">
                  <li>
                    <NavLink
                      to="#"
                      onClick={toggleMenuWorkflow}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpen ? faCaretDown : faCaretRight}
                        className="pull-right"
                        style={{ marginLeft: "8px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faChartDiagram}
                          style={{ color: "#453e3e", fontSize: "18px" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Workflow
                      </span>
                    </NavLink>
                    {isOpenWorkflow && (
                      <ul className="sub-menu">
                        <PermissionWrapper module="workflow_lead" action="view">
                          <li>
                            <NavLink
                              to="/Workflow/LeadCreation"
                              onClick={clearLeadCreationFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Lead Creation</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="workflow_subscriber"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Workflow/Subscriber"
                              onClick={clearWorkflowSubscriberFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Subcriber</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="workflow_subscription"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Workflow/Subscription"
                              onClick={clearWorkflowSubscriptionFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Subscription</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="workflow_order"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Workflow/Order"
                              onClick={clearWorkflowOrderFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Order</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                      </ul>
                    )}
                  </li>
                </PermissionWrapper>
                {/* <PermissionWrapper module="workflow" action="view">
                <li>
                  <NavLink
                    to="#"
                    onClick={toggleMenuWorkflow}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon
                      icon={isOpen ? faCaretDown : faCaretRight}
                      className="pull-right"
                      style={{ marginLeft: "8px" }}
                    />
                    <FontAwesomeIcon icon={faGear} />
                    <span> Workflow Tradepro</span>
                  </NavLink>
                  {isOpenWorkflow && (
                    <ul className="sub-menu">
                      <PermissionWrapper module="workflow_lead" action="view">
                        <li>
                            <NavLink
                              to="/WorkflowTradepro/LeadCreation"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Lead Creation</span>
                          </NavLink>
                        </li>
                      </PermissionWrapper>
                      <PermissionWrapper
                        module="workflow_subscriber"
                        action="view"
                      >
                        <li>
                            <NavLink
                              to="/WorkflowTradepro/Subscriber"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Subcriber</span>
                          </NavLink>
                        </li>
                      </PermissionWrapper>
                      <PermissionWrapper
                        module="workflow_subscription"
                        action="view"
                      >
                        <li>
                            <NavLink
                              to="/WorkflowTradepro/Subscription"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Subscription</span>
                          </NavLink>
                        </li>
                      </PermissionWrapper>
                      <PermissionWrapper module="workflow_order" action="view">
                        <li>
                            <NavLink
                              to="/WorkflowTradepro/Order"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Order</span>
                          </NavLink>
                        </li>
                      </PermissionWrapper>
                    </ul>
                  )}
                </li>
              </PermissionWrapper>

              <PermissionWrapper module="workflow" action="view">
                <li>
                  <NavLink
                    to="#"
                    onClick={toggleMenuWorkflow}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon
                      icon={isOpen ? faCaretDown : faCaretRight}
                      className="pull-right"
                      style={{ marginLeft: "8px" }}
                    />
                    <FontAwesomeIcon icon={faGear} />
                    <span> Workflow Streetfolio</span>
                  </NavLink>
                  {isOpenWorkflow && (
                    <ul className="sub-menu">
                      <PermissionWrapper module="workflow_lead" action="view">
                        <li>
                            <NavLink
                              to="/WorkflowStreetfolio/LeadCreation"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Lead Creation</span>
                          </NavLink>
                        </li>
                      </PermissionWrapper>
                      <PermissionWrapper
                        module="workflow_subscriber"
                        action="view"
                      >
                        <li>
                            <NavLink
                              to="/WorkflowStreetfolio/Subscriber"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Subcriber</span>
                          </NavLink>
                        </li>
                      </PermissionWrapper>
                      <PermissionWrapper
                        module="workflow_subscription"
                        action="view"
                      >
                        <li>
                            <NavLink
                              to="/WorkflowStreetfolio/Subscription"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Subscription</span>
                          </NavLink>
                        </li>
                      </PermissionWrapper>
                      <PermissionWrapper module="workflow_order" action="view">
                        <li>
                            <NavLink
                              to="/WorkflowStreetfolio/Order"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Order</span>
                          </NavLink>
                        </li>
                      </PermissionWrapper>
                    </ul>
                  )}
                </li>
              </PermissionWrapper> */}

                <PermissionWrapper module="hrms" action="view">
                  <li>
                    <NavLink
                      to="#"
                      onClick={toggleMenu}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpen ? faCaretDown : faCaretRight}
                        className="pull-right"
                        style={{ marginLeft: "8px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faUsersGear}
                          style={{ color: "#453e3e", fontSize: "18px" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        HRMS
                      </span>
                    </NavLink>
                    {isOpenReport && (
                      <ul className="sub-menu">
                        <PermissionWrapper module="hrms_user" action="view">
                          <li>
                            <NavLink
                              to="/Hrms/User"
                              onClick={clearHRMSUserManagementFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> User Management</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="hrms_distributor_user" action="view">
                          <li>
                            <NavLink
                              to="/Hrms/DistributorUser"
                              onClick={clearHRMSDistributorUserManagementFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Distributor Management</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="hrms_esimgmt" action="view">
                          <li>
                            <NavLink
                              to="/Hrms/EsiManagement"
                              onClick={clearEsiManagementFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> ESI Management</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="hrms_role" action="view">
                          <li>
                            <NavLink
                              to="/Hrms/Role"
                              onClick={clearRoleManagementFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Role Management</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="hrms_history" action="view">
                          <li>
                            <NavLink
                              to="/Hrms/LoginHistory"
                              onClick={clearLoginHistoryFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Login History</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        {/* <PermissionWrapper module="hrms_staff_attendance" action="view">
                        <li>
                          <NavLink
                            to="/user-manager"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> Staff Attendance</span>
                          </NavLink>
                        </li>
                      </PermissionWrapper> */}
                        <PermissionWrapper
                          module="hrms_staff_attendance"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Hrms/StaffAttendance"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Staff Attendance</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="hrms_user_ip" action="view">
                          <li>
                            <NavLink
                              to="/user-manager"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> User IP Management</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        {/* <PermissionWrapper module="hrms_role" action="view">
                        <li>
                          <NavLink
                            to="/user-manager"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> HRMS Setup</span>
                          </NavLink>
                        </li>
                      </PermissionWrapper> */}
                        <PermissionWrapper module="hrms_role" action="view">
                          <li>
                            <NavLink
                              to="/user-manager"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Chat Group</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                      </ul>
                    )}
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="reports" action="view">
                  <li>
                    <NavLink
                      to="#"
                      onClick={toggleMenuReport}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpenReport ? faCaretDown : faCaretRight}
                        className="pull-right"
                        style={{ marginLeft: "8px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faFileInvoice}
                          style={{ color: "#453e3e", fontSize: "18px" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Report
                      </span>
                    </NavLink>
                    {isOpenReport && ( // âœ… Now using the correct state variable
                      <ul className="sub-menu">
                        {/* <PermissionWrapper module="single_bulkcampaign" action="view"> */}
                        {/* <li>
                          <NavLink
                            to="/Report/Salary"
                            className={({ isActive }) => (isActive ? "active" : "")}
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>Salary Report</span>
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/Report/Installation"
                            className={({ isActive }) => (isActive ? "active" : "")}
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span>Installation Report</span>
                          </NavLink>
                        </li> */}
                        {/* <PermissionWrapper module="Report_rides" action="view"> */}
                        <PermissionWrapper module="report_subscription" action="view">
                          <li>
                            <NavLink
                              to="/Report/Subscription"
                              onClick={clearSubscriptionReportFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Subscription Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="report_distributor" action="view">
                          <li>
                            <NavLink
                              to="/Report/Distributor"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Distributor Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="report_ads" action="view">
                          <li>
                            <NavLink
                              to="/Report/adsReport"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Ads Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="report_subscriberstatus" action="view">
                          <li>
                            <NavLink
                              to="/Report/SubscriberStatus"
                              onClick={clearSubscriberStatusReportFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Subscriber Status Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="report_subscriber_data" action="view">
                          <li>
                            <NavLink
                              to="/Report/subscriberData"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Subscriber Data Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="report_callsummary" action="view">
                          <li>
                            <NavLink
                              to="/Report/callSummary/report"
                              onClick={clearCallSummaryReportFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Call Summary Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="report_emailstatistics" action="view">
                          <li>
                            <NavLink
                              to="/Report/emailStatistics"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Email Statistics Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="whatsapp_chat_report" action="view">
                          <li>
                            <NavLink
                              to="/Report/whatsappReport"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Whatsapp Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="whatsapp_optin" action="view">
                          <li>
                            <NavLink
                              to="/Report/whatsappOptin"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Whatsapp Optin</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="report_linktracking" action="view">
                          <li>
                            <NavLink
                              to="/Report/linkTracking"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Link Tracking Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="report_revenue" action="view">
                          <li>
                            <NavLink
                              to="/Report/revenueReport"
                              onClick={clearRevenueReportFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Revenue Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="report_subscriber_analysis" action="view">
                          <li>
                            <NavLink
                              to="/Report/subscriberAnalysisReport"
                              onClick={clearSubscriberAnalysisReportFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Subscriber Analysis</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="report_subscription_analysis" action="view">
                          <li>
                            <NavLink
                              to="/Report/subscriptionAnalysisReport"
                              onClick={clearSubscriptionAnalysisReportFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Subscription Analysis</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="subscriber_analysis_chart" action="view">
                          <li>
                            <NavLink
                              to="/Report/subscriberAnalysisChart"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Subscriber Chart</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="subscription_analysis_chart" action="view">
                          <li>
                            <NavLink
                              to="/Report/subscriptionAnalysisChart"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Subscription Chart</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="revenue_chart" action="view">
                          <li>
                            <NavLink
                              to="/Report/revenueChart"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Revenue Chart</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="website_leadsourcecost" action="view">
                          <li>
                            <NavLink
                              to="/Website/LeadSourceCost"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Lead Source Cost</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="lead_source_report" action="view">
                          <li>
                            <NavLink
                              to="/Report/leadSourceReport"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Lead Source Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        {/* <PermissionWrapper module="Report_rides" action="view">
                          <li>
                            <NavLink
                              to="/Twitter/getTwitterPost"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Twitter</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper> */}
                        {/* </PermissionWrapper> */}
                        <PermissionWrapper
                          module="report_bulkcampaign"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Report/BulkCampaign"
                              onClick={clearBulkCampingReportReportFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Bulk campaign report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="single_bulkcampaign"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Report/SingleCampaign"
                              onClick={clearSingleCampingReportReportFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Single campaign report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="single_bulkcampaign"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Report/Broadcast"
                              onClick={clearBroadCastReportReportFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Broadcast report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="report_executive_performance"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Report/ExecutivePerformance"
                              onClick={clearExecutivePerformanceReportFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Executive report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>

                      </ul>
                    )}
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="ticket" action="view">
                  <li>
                    <NavLink
                      to="#"
                      onClick={toggleMenuTicket}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpen ? faCaretDown : faCaretRight}
                        className="pull-right"
                        style={{ marginLeft: "8px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faTicket}
                          style={{ color: "#453e3e", fontSize: "18px" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Ticket
                      </span>
                    </NavLink>
                    {isOpenTicket && (
                      <ul className="sub-menu">
                        <PermissionWrapper
                          module="ticket_category"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Ticket/Category"
                              onClick={clearCategoryFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Category</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="ticket_listing"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Ticket/Main/tickets/1"
                              onClick={clearTicketFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Research Tickets</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="ticket_listing"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Ticket/Main/tickets/2"
                              onClick={clearTicketFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Technical Tickets</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="dev_ticket_listing"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/DevTicket/Ticket"
                              onClick={clearDevTicketFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Dev Tickets</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                      </ul>
                    )}
                  </li>
                </PermissionWrapper>
                {/* <li>
                <NavLink
                  to="#"
                  onClick={toggleMenuSeo}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <FontAwesomeIcon
                    icon={isOpen ? faCaretDown : faCaretRight}
                    className="pull-right"
                    style={{ marginLeft: "8px" }}
                  />
                  <FontAwesomeIcon icon={faGear} />
                  <span> Seo</span>
                </NavLink>
                {isOpenSeo && <ul className="sub-menu"></ul>}
              </li> */}
                <PermissionWrapper module="general" action="view">
                  <li>
                    <NavLink
                      to="#"
                      onClick={toggleMenuGeneral}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpen ? faCaretDown : faCaretRight}
                        className="pull-right"
                        style={{ marginLeft: "8px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faSliders}
                          style={{ color: "#453e3e", fontSize: "18px" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        General
                      </span>
                    </NavLink>
                    {isOpenGeneral && (
                      <ul className="sub-menu">
                        {/* <li>
                              <NavLink
                                to="/Website/StreetViewCategory"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <FontAwesomeIcon icon={faAngleRight} />
                        <span> StreetView Category</span>
                      </NavLink>
                    </li>
                    <li>
                              <NavLink
                                to="/Website/Offers"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <FontAwesomeIcon icon={faAngleRight} />
                        <span> Offers</span>
                      </NavLink>
                    </li>
                    <li>
                              <NavLink
                                to="/Website/Testimonial"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <FontAwesomeIcon icon={faAngleRight} />
                        <span> Testimonial</span>
                      </NavLink>
                    </li> */}
                        {/* <PermissionWrapper module="seo" action="view"> */}
                        {(hasPermission("seo_portfolio", "view") ||
                          hasPermission("seo_credits", "view")) && (
                            <li>
                              <NavLink
                                to="/Seo/Services"
                                onClick={clearServiceFilters}
                                className={({ isActive }) =>
                                  isActive ? "active" : ""
                                }
                              >
                                <FontAwesomeIcon icon={faAngleRight} />
                                <span> Services Seo</span>
                              </NavLink>
                            </li>
                          )}
                        <PermissionWrapper module="seo_pages" action="view">
                          <li>
                            <NavLink
                              to="/Seo/Pages"
                              onClick={clearPageFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Pages Seo</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="extra_pages" action="view">
                          <li>
                            <NavLink
                              to="/Seo/ServicePages"
                              onClick={clearServicePageFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Extra Pages</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        {/* <li>
                      <NavLink
                        to="/Seo/Webstories"
                        className={({ isActive }) => (isActive ? "active" : "")}
                      >
                        <FontAwesomeIcon icon={faAngleRight} />
                        <span> Webstories</span>
                      </NavLink>
                    </li> */}
                        {/* <PermissionWrapper
                        module="website_askexpert"
                        action="view"
                      >
                        <li>
                            <NavLink
                              to="/Website/AskExpert"
                            className={({ isActive }) =>
                              isActive ? "active" : ""
                            }
                          >
                            <FontAwesomeIcon icon={faAngleRight} />
                            <span> AskExpert</span>
                          </NavLink>
                        </li>
                      </PermissionWrapper> */}
                        <PermissionWrapper module="policy_pages" action="view">
                          <li>
                            <NavLink
                              to="/CustomPages"
                              onClick={clearCustomPageFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span>Policy Pages</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="dynamic_blogs" action="view">
                          <li>
                            <NavLink
                              to="/DynamicBlogs"
                              onClick={clearDynamicBlogFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Dynamic Blogs</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        {(hasPermission("streetgains_sitemap", "view") ||
                          hasPermission("streetfolio_sitemap", "view")) && (
                            <li>
                              <NavLink
                                to="/Website/Sitemap"
                                onClick={clearWebsiteSitemapFilters}
                                className={({ isActive }) =>
                                  isActive ? "active" : ""
                                }
                              >
                                <FontAwesomeIcon icon={faAngleRight} />
                                <span>Website Sitemap</span>
                              </NavLink>
                            </li>
                          )}
                        {/* </PermissionWrapper> */}
                        {(hasPermission("streetgains_reviews", "view") ||
                          hasPermission("streetfolio_reviews", "view")) && (
                            <li>
                              <NavLink
                                to="/WebsiteReviews"
                                onClick={clearWebsiteReviewsFilters}
                                className={({ isActive }) =>
                                  isActive ? "active" : ""
                                }
                              >
                                <FontAwesomeIcon icon={faAngleRight} />
                                <span>Website Reviews</span>
                              </NavLink>
                            </li>
                          )}
                      </ul>
                    )}
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="payroll" action="view">
                  <li>
                    <NavLink
                      to="#"
                      onClick={toggleMenuPayroll}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpen ? faCaretDown : faCaretRight}
                        className="pull-right"
                        style={{ marginLeft: "8px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faMoneyBillTransfer}
                          style={{ color: "#453e3e", fontSize: "18px" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Payroll
                      </span>
                    </NavLink>
                    {isOpenPayroll && (
                      <ul className="sub-menu">
                        <PermissionWrapper
                          module="payroll_set_salary"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Payroll/SetSalary/list"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Set Salary</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="payroll_employee"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Payroll/Employee/index/"
                              onClick={clearEmployeeSalaryFilters}
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Employee</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="payroll_salary_report"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Payroll/SalaryReport"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Salary Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper
                          module="payroll_salary_report"
                          action="view"
                        >
                          <li>
                            <NavLink
                              to="/Payroll/PayrollReport"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Payroll Report</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                      </ul>
                    )}
                  </li>
                </PermissionWrapper>

                <PermissionWrapper module="chat" action="view">
                  <li>
                    <NavLink
                      to="/botsense-chat"
                      className={({ isActive }) =>
                        isActive ? "active" : "nav-link"
                      }
                    >
                      <span style={{ fontWeight: "bold" }}>
                        {" "}
                        <FontAwesomeIcon
                          icon={faComments}
                          style={{ fontSize: "18px", color: "#453e3e" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Chat
                      </span>
                    </NavLink>
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="whatsapp_chat" action="view">
                  <li>
                    <NavLink
                      to="/whatsapp-chat"
                      className={({ isActive }) =>
                        isActive ? "active" : "nav-link"
                      }
                    >
                      <span style={{ fontWeight: "bold" }}>
                        {" "}
                        <FontAwesomeIcon
                          icon={faWhatsapp}
                          style={{ fontSize: "18px", color: "#453e3e" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        WhatsApp Chat
                      </span>
                    </NavLink>
                  </li>
                </PermissionWrapper>
                <PermissionWrapper module="freshdesk" action="view">
                  <li>
                    <NavLink
                      to="/freshdesk"
                      className={({ isActive }) =>
                        isActive ? "active" : "nav-link"
                      }
                    >
                      <span style={{ fontWeight: "bold" }}>
                        {" "}
                        <FontAwesomeIcon
                          icon={faHeadset}
                          style={{ fontSize: "18px", color: "#453e3e" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Freshdesk
                      </span>
                    </NavLink>
                  </li>
                </PermissionWrapper>
                {/* <PermissionWrapper module="leave_management" action="view">
                <li>
                  <NavLink
                    to="#"
                    onClick={toggleMenuLeaveManagement}
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <FontAwesomeIcon
                      icon={isOpen ? faCaretDown : faCaretRight}
                      className="pull-right"
                      style={{ marginLeft: "8px" }}
                    />
                    <FontAwesomeIcon icon={faGear} />
                    <span> Leave Management</span>
                  </NavLink>
                  {isOpenLeaveManagement && (
                    <ul className="sub-menu">
                      <li>
                          <NavLink
                            to="/LeaveManagement/LeaveType/index"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Leave Type</span>
                        </NavLink>
                      </li>
                      <li>
                          <NavLink
                            to="/LeaveManagement/ApplyLeave/index"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Apply Leave</span>
                        </NavLink>
                      </li>
                      <li>
                          <NavLink
                            to="/LeaveManagement/ManageLeaves/index"
                          className={({ isActive }) =>
                            isActive ? "active" : ""
                          }
                        >
                          <FontAwesomeIcon icon={faAngleRight} />
                          <span> Manage Leave</span>
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li>
              </PermissionWrapper> */}

                <PermissionWrapper module="ai_voice_calling" action="view">
                  <li>
                    <NavLink
                      to="/AICallCampaigns"
                      className={({ isActive }) =>
                        isActive ? "active" : ""
                      }
                    >
                      <FontAwesomeIcon icon={faHeadset} />
                      <span> AI Voice Calling</span>
                    </NavLink>
                  </li>
                </PermissionWrapper>

                <PermissionWrapper module="sarvam_ai_call_campaign" action="view">
                  <li>
                    <NavLink
                      to="/AISarvamVoiceCalling"
                      className={({ isActive }) =>
                        isActive ? "active" : ""
                      }
                    >
                      <FontAwesomeIcon icon={faHeadset} />
                      <span> AI Sarvam Voice Calling</span>
                    </NavLink>
                  </li>
                </PermissionWrapper>

                {/* Street Learn Menu */}
                <PermissionWrapper module="streetlearn" action="view">
                  <li>
                    <NavLink
                      to="#"
                      onClick={(e) => toggleMenuStreetlearn(e)}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <FontAwesomeIcon
                        icon={isOpenStreetlearn ? faCaretDown : faCaretRight}
                        className="pull-right"
                        style={{ marginLeft: "8px" }}
                      />
                      <span style={{ fontWeight: "bold" }}>
                        <FontAwesomeIcon
                          icon={faGraduationCap}
                          style={{ color: "#453e3e", fontSize: "18px" }}
                        />
                      </span>
                      <span style={{ fontWeight: "bold", color: "#453e3e" }}>
                        {" "}
                        Street Learn
                      </span>
                    </NavLink>
                    {isOpenStreetlearn && (
                      <ul className="sub-menu" style={{ display: "block" }}>
                        <PermissionWrapper module="streetlearn" action="view">
                          <li>
                            <NavLink
                              to="/streetlearn/analytics"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Analytics & Funnel</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="streetlearn_learners" action="view">
                          <li>
                            <NavLink
                              to="/streetlearn/learners"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Learners</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="streetlearn" action="view">
                          <li>
                            <NavLink
                              to="/streetlearn/curriculum"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Curriculum & Studio</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="streetlearn" action="view">
                          <li>
                            <NavLink
                              to="/streetlearn/questions"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Question Bank</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="streetlearn" action="view">
                          <li>
                            <NavLink
                              to="/streetlearn/exam-settings"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Exam Rules</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="streetlearn_orders" action="view">
                          <li>
                            <NavLink
                              to="/streetlearn/orders"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Orders</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                        <PermissionWrapper module="streetlearn_learners" action="view">
                          <li>
                            <NavLink
                              to="/streetlearn/certificates"
                              className={({ isActive }) =>
                                isActive ? "active" : ""
                              }
                            >
                              <FontAwesomeIcon icon={faAngleRight} />
                              <span> Certificates</span>
                            </NavLink>
                          </li>
                        </PermissionWrapper>
                      </ul>
                    )}
                  </li>
                </PermissionWrapper>

                <li className="nav-divider"></li>
                {/* <span className=" text-muted font ms-3 fs-6" style={{fontSize: "1px !important"}}>Â© 2025 StreetgainsAll</span><br />
              <span className=" text-muted ms-3 fs-6" style={{fontSize: "1px !important"}}>Right Reserved</span> */}
              </ul>
            </SimpleBar>
          </div>
        </div>
      </div >
    </>
  );
};

export default Sidebar;

// SidebarDropdown: Searchable dropdown for sidebar navigation
const sidebarItems = [
  // Dashboard
  { label: "Dashboard", path: "/dashboard", category: "Dashboard" },
  { label: "Distributor Dashboard", path: "/distributor-dashboard", category: "Dashboard" },
  { label: "My Dashboard", path: "/my-dashboard", category: "Dashboard" },

  // Research
  { label: "Markets", path: "/research/markets", category: "Research" },
  {
    label: "Add Notifications",
    path: "/research/notifications/add",
    category: "Research",
  },
  {
    label: "Notifications",
    path: "/research/notifications",
    category: "Research",
  },
  // {
  //   label: "Add Angle Notifications",
  //   path: "/research/angel-notifications/add",
  //   category: "Research",
  // },
  // {
  //   label: "Angle Notifications",
  //   path: "/research/angel-notifications",
  //   category: "Research",
  // },
  {
    label: "Market Hourly Report",
    path: "/research/markets/hourly/report",
    category: "Research",
  },
  {
    label: "Hourly Commentary",
    path: "/research/markets/hourly/commentary",
    category: "Research",
  },
  {
    label: "Research Calls",
    path: "/research/performance",
    category: "Research",
  },
  { label: "Portfolio", path: "/research/Portfolio", category: "Research" },
  { label: "Services", path: "/research/Services", category: "Research" },
  { label: "Symbol", path: "/research/Symbol", category: "Research" },
  { label: "StreetView", path: "/research/StreetView", category: "Research" },
  {
    label: "Social Sharing",
    path: "/research/SocialSharing",
    category: "Research",
  },
  { label: "Whatsapp", path: "/research/whatsapp", category: "Research" },
  { label: "Email", path: "/research/SendMail", category: "Research" },
  { label: "SG Messages", path: "/research/sg-messages", category: "Research" },
  { label: "SF Messages", path: "/research/sf-messages", category: "Research" },
  {
    label: "Push Notifications",
    path: "/Campaign/PushNotification",
    category: "Research",
  },
  {
    label: "Research History",
    path: "/Research/NotificationHistory",
    category: "Research",
  },
  {
    label: "Street Analysis",
    path: "/research/patterns-radar",
    category: "Research",
  },
  {
    label: "Careparrva Output",
    path: "/research/careparrva-output",
    category: "Research",
  },

  // Subscriber
  {
    label: "Subscriber",
    path: "/Subscriber",
    category: "Subscriber",
  },
  {
    label: "Recent Subscribers",
    path: "/Subscriber?filter=RecentSubscriber",
    category: "Subscriber",
  },
  {
    label: "Recent Contacted",
    path: "/Subscriber?filter=RecentContacted",
    category: "Subscriber",
  },
  {
    label: "New Subscribers",
    path: "/Subscriber?filter=New",
    category: "Subscriber",
  },
  {
    label: "Contact Today",
    path: "/Subscriber?filter=ContactToday",
    category: "Subscriber",
  },
  {
    label: "Future Contact",
    path: "/Subscriber?filter=FutureContact",
    category: "Subscriber",
  },
  {
    label: "Not Interested",
    path: "/Subscriber?filter=NotInterested",
    category: "Subscriber",
  },
  {
    label: "No Response",
    path: "/Subscriber?filter=NoResponse",
    category: "Subscriber",
  },
  {
    label: "Prospect",
    path: "/Subscriber?filter=Prospect",
    category: "Subscriber",
  },
  {
    label: "Subscribed",
    path: "/Subscriber?filter=Subscribed",
    category: "Subscriber",
  },
  { label: "Junk", path: "/Subscriber?filter=Junk", category: "Subscriber" },
  {
    label: "Incoming Call Report",
    path: "/Report/callSummary",
    category: "Subscriber",
  },

  // Subscription
  // {
  //   label: "Subscription",
  //   path: "/Subscription",
  //   category: "Subscription",
  // },
  // {
  //   label: "Free Subscription",
  //   path: "/Subscription?type=free",
  //   category: "Subscription",
  // },
  // {
  //   label: "Free Active",
  //   path: "/Subscription?type=free_active",
  //   category: "Subscription",
  // },
  // {
  //   label: "Expired Today",
  //   path: "/Subscription?type=expired_today",
  //   category: "Subscription",
  // },
  // {
  //   label: "Free Expired",
  //   path: "/Subscription?type=free_expired",
  //   category: "Subscription",
  // },
  // {
  //   label: "Performance",
  //   path: "/Subscription?type=performance",
  //   category: "Subscription",
  // },
  // { label: "Paid", path: "/Subscription?type=paid", category: "Subscription" },
  // {
  //   label: "Paid Active",
  //   path: "/Subscription?type=paid_active",
  //   category: "Subscription",
  // },
  // {
  //   label: "Paid InProgress",
  //   path: "/Subscription?type=paid_inprogress",
  //   category: "Subscription",
  // },
  // {
  //   label: "Paid Expired",
  //   path: "/Subscription?type=paid_expired",
  //   category: "Subscription",
  // },
  // {
  //   label: "Duplicates",
  //   path: "/Subscription?type=duplicates",
  //   category: "Subscription",
  // },
  // {
  //   label: "Pending Approval",
  //   path: "/Subscription?type=pending_approval",
  //   category: "Subscription",
  // },
  {
    label: "Subscription Credits",
    path: "/SubscriptionCredits",
    category: "SubscriptionCredits",
  },
  {
    label: "Free",
    path: "/SubscriptionCredits?filter=Free",
    category: "SubscriptionCredits",
  },
  {
    label: "Free Active",
    path: "/SubscriptionCredits?filter=FreeActive",
    category: "SubscriptionCredits",
  },
  {
    label: "Expired Today",
    path: "/SubscriptionCredits?filter=ExpiredToday",
    category: "SubscriptionCredits",
  },
  {
    label: "Free Expired",
    path: "/SubscriptionCredits?filter=FreeExpired",
    category: "SubscriptionCredits",
  },
  {
    label: "Performance",
    path: "/SubscriptionCredits?type=performance",
    category: "SubscriptionCredits",
  },
  {
    label: "Paid",
    path: "/SubscriptionCredits?filter=Paid",
    category: "SubscriptionCredits",
  },
  {
    label: "Paid Active",
    path: "/SubscriptionCredits?filter=PaidActive",
    category: "SubscriptionCredits",
  },
  {
    label: "Paid InProgress",
    path: "/SubscriptionCredits?filter=PaidInProgress",
    category: "SubscriptionCredits",
  },
  {
    label: "Paid Expired",
    path: "/SubscriptionCredits?filter=PaidExpired",
    category: "SubscriptionCredits",
  },
  {
    label: "Duplicates",
    path: "/SubscriptionCredits?filter=Duplicated",
    category: "SubscriptionCredits",
  },
  {
    label: "Pending Approval",
    path: "/SubscriptionCredits?type=pending_approval",
    category: "SubscriptionCredits",
  },

  {
    label: "Subscription Portfolio",
    path: "/SubscriptionPortfolio",
    category: "SubscriptionPortfolio",
  },
  // {
  //   label: "Free",
  //   path: "/SubscriptionPortfolio?filter=Free",
  //   category: "SubscriptionPortfolio",
  // },
  // {
  //   label: "Free Active",
  //   path: "/SubscriptionPortfolio?filter=FreeActive",
  //   category: "SubscriptionPortfolio",
  // },
  {
    label: "Paid",
    path: "/SubscriptionPortfolio?filter=Paid",
    category: "SubscriptionPortfolio",
  },
  {
    label: "Paid Active",
    path: "/SubscriptionPortfolio?filter=PaidActive",
    category: "SubscriptionPortfolio",
  },
  {
    label: "Paid Expired",
    path: "/SubscriptionPortfolio?filter=PaidExpired",
    category: "SubscriptionPortfolio",
  },
  {
    label: "Expired Today",
    path: "/SubscriptionPortfolio?filter=ExpiredToday",
    category: "SubscriptionPortfolio",
  },
  {
    label: "Renewed",
    path: "/SubscriptionPortfolio?filter=Renewed",
    category: "SubscriptionPortfolio",
  },
  // {
  //   label: "Free Expired",
  //   path: "/SubscriptionPortfolio?filter=FreeExpired",
  //   category: "SubscriptionPortfolio",
  // },
  // {
  //   label: "Performance",
  //   path: "/SubscriptionPortfolio?type=performance",
  //   category: "SubscriptionPortfolio",
  // },
  // Paid InProgress was commented in your code
  // Uncomment below if you want it
  // {
  //   label: "Paid InProgress",
  //   path: "/SubscriptionPortfolio?filter=PaidInProgress",
  //   category: "SubscriptionPortfolio",
  // },
  // {
  //   label: "Duplicates",
  //   path: "/SubscriptionPortfolio?filter=Duplicated",
  //   category: "SubscriptionPortfolio",
  // },
  // Pending Approval was commented in your code
  // Uncomment below if you need it
  // {
  //   label: "Pending Approval",
  //   path: "/SubscriptionPortfolio?type=pending_approval",
  //   category: "SubscriptionPortfolio",
  // },
  // Orders
  { label: "Orders", path: "/Order", category: "Orders" },
  {
    label: "Orders Settlements",
    path: "/Orders/settlements",
    category: "Orders",
  },

  // Settings
  { label: "Company Info", path: "/Settings/Company", category: "Settings" },
  {
    label: "AI Prompts",
    path: "/Settings/AiCallingPrompts",
    category: "Settings",
  },
  {
    label: "Email Configurations",
    path: "/Settings/EmailConfig",
    category: "Settings",
  },
  {
    label: "Email Mapping",
    path: "/Settings/EmailMapping",
    category: "Settings",
  },
  {
    label: "Template Email",
    path: "/Settings/TemplateEmail",
    category: "Settings",
  },
  {
    label: "Template SMS",
    path: "/Settings/TemplateSms",
    category: "Settings",
  },
  {
    label: "Template Push Notification",
    path: "/Settings/TemplatePushNotification",
    category: "Settings",
  },
  {
    label: "Template Whatsapp ",
    path: "/Settings/TemplateWhatsappNotification",
    category: "Settings",
  },
  {
    label: "Template Research",
    path: "/Settings/TemplateResearch",
    category: "Settings",
  },
  {
    label: "Media Upload",
    path: "/Settings/MediaUpload",
    category: "Settings",
  },
  {
    label: "Template Bulk Camping",
    path: "/Settings/TemplateBulkCampaign",
    category: "Settings",
  },
  {
    label: "Pickup List",
    path: "/Settings/Pickuplist/crm",
    category: "Settings",
  },
  {
    label: "Investor Charter",
    path: "/Settings/InvestorCharter",
    category: "Settings",
  },
  {
    label: "Incentive Rule",
    path: "/Settings/IncentiveRule",
    category: "Settings",
  },
  {
    label: "Configurations Templates",
    path: "/Settings/ConfigurationsTemplates",
    category: "Settings",
  },
  // Research
  {
    label: "Product Subscriptions",
    path: "/research/ProductSubscriptions",
    category: "Research",
  },

  // Workflow
  {
    label: "Lead Creation",
    path: "/Workflow/LeadCreation",
    category: "Workflow",
  },
  {
    label: "Subscriber Workflow",
    path: "/Workflow/Subscriber",
    category: "Workflow",
  },
  {
    label: "Subscription Workflow",
    path: "/Workflow/Subscription",
    category: "Workflow",
  },
  { label: "Order Workflow", path: "/Workflow/Order", category: "Workflow" },

  // Workflow Streetfolio
  // {
  //   label: "Lead Creation",
  //   path: "/WorkflowStreetfolio/LeadCreation",
  //   category: "Workflow Streetfolio",
  // },
  // {
  //   label: "Subscriber Workflow",
  //   path: "/WorkflowStreetfolio/Subscriber",
  //   category: "Workflow Streetfolio",
  // },
  // {
  //   label: "Subscription Workflow",
  //   path: "/WorkflowStreetfolio/Subscription",
  //   category: "Workflow Streetfolio",
  // },
  // {
  //   label: "Order Workflow",
  //   path: "/WorkflowStreetfolio/Order",
  //   category: "Workflow Streetfolio",
  // },

  // // Workflow Tradepro
  // {
  //   label: "Lead Creation",
  //   path: "/WorkflowTradepro/LeadCreation",
  //   category: "Workflow Tradepro",
  // },
  // {
  //   label: "Subscriber Workflow",
  //   path: "/WorkflowTradepro/Subscriber",
  //   category: "Workflow Tradepro",
  // },
  // {
  //   label: "Subscription Workflow",
  //   path: "/WorkflowTradepro/Subscription",
  //   category: "Workflow Tradepro",
  // },
  // {
  //   label: "Order Workflow",
  //   path: "/WorkflowTradepro/Order",
  //   category: "Workflow Tradepro",
  // },

  // HRMS
  { label: "User Management", path: "/Hrms/User", category: "HRMS" },
  { label: "Distributor Management", path: "/Hrms/DistributorUser", category: "HRMS" },
  { label: "ESI Management", path: "/Hrms/EsiManagement", category: "HRMS" },
  { label: "Role Management", path: "/Hrms/Role", category: "HRMS" },
  { label: "Login History", path: "/Hrms/LoginHistory", category: "HRMS" },
  {
    label: "Staff Attendance",
    path: "/Hrms/StaffAttendance",
    category: "HRMS",
  },

  //Report
  { label: "Bulk Campaing", path: "/Report/BulkCampaign", category: "Report" },
  { label: "Executive Report", path: "/Report/ExecutivePerformance", category: "Report" },

  // Ticket
  { label: "Ticket Category", path: "/Ticket/Category", category: "Ticket" },
  {
    label: "Research Tickets",
    path: "/Ticket/Main/tickets/1",
    category: "Ticket",
  },
  {
    label: "Technical Tickets",
    path: "/Ticket/Main/tickets/2",
    category: "Ticket",
  },
  { label: "Dev Tickets", path: "/DevTicket/Ticket", category: "Ticket" },

  // General
  { label: "Services", path: "/Seo/Services", category: "General" },
  { label: "Pages", path: "/Seo/Pages", category: "General" },
  { label: "Extra Pages", path: "/Seo/ServicePages", category: "General" },
  // { label: "Webstories", path: "/Seo/Webstories", category: "General" },
  // { label: "AskExpert", path: "/Website/AskExpert", category: "General" },
  { label: "Custom Pages", path: "/CustomPages", category: "General" },
  { label: "Dynamic Blogs", path: "/DynamicBlogs", category: "General" },
  { label: "Website Sitemap", path: "/Website/Sitemap", category: "General" },
  { label: "Website Reviews", path: "/WebsiteReviews", category: "General" },

  // Payroll
  { label: "Set Salary", path: "/Payroll/SetSalary/list", category: "Payroll" },
  { label: "Employee", path: "/Payroll/Employee/index", category: "Payroll" },
  {
    label: "Salary Report",
    path: "/Payroll/SalaryReport",
    category: "Payroll",
  },

  // Leave Management
  // {
  //   label: "Leave Type",
  //   path: "/LeaveManagement/LeaveType/index",
  //   category: "Leave Management",
  // },
  // {
  //   label: "Apply Leave",
  //   path: "/LeaveManagement/ApplyLeave/index",
  //   category: "Leave Management",
  // },
  // {
  //   label: "Manage Leave",
  //   path: "/LeaveManagement/ManageLeaves/index",
  //   category: "Leave Management",
  // },

  // AI Voice Calling
  {
    label: "AI Voice Calling",
    path: "/AICallCampaigns",
    category: "AI Voice Calling",
  },
  {
    label: "AI Sarvam Voice Calling",
    path: "/AISarvamVoiceCalling",
    category: "AI Voice Calling",
  },
];

function SidebarDropdown({ navigate }) {
  const [search, setSearch] = useState("");
  const [showList, setShowList] = useState(false);
  const dropdownRef = useRef(null);

  // Add click outside handler
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowList(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const filtered = sidebarItems
    .filter(
      (item) =>
        item.label.toLowerCase().includes(search.toLowerCase()) ||
        item.category.toLowerCase().includes(search.toLowerCase())
    );

  const handleSelect = (item) => {
    setShowList(false);
    setSearch("");
    navigate(item.path);
  };

  // Group items by category
  const groupedItems = filtered.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});

  // return (
  //   <div style={{ position: "relative" }} ref={dropdownRef}>
  //     <input
  //       type="text"
  //       className="form-control"
  //       placeholder="Search menu items..."
  //       value={search}
  //       onFocus={() => setShowList(true)}
  //       onChange={(e) => {
  //         setSearch(e.target.value);
  //         setShowList(true);
  //       }}
  //       style={{
  //         width: "100%",
  //         fontSize: "11px",
  //         padding: "8px 12px",
  //         height: "34px",
  //       }}
  //     />
  //     {showList && (
  //       <ul
  //         style={{
  //           position: "absolute",
  //           zIndex: 9999,
  //           background: "#fff",
  //           width: "100%",
  //           maxHeight: "300px",
  //           overflowY: "auto",
  //           border: "1px solid #ccc",
  //           margin: 0,
  //           padding: 0,
  //           listStyle: "none",
  //           boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
  //           fontSize: "11px",
  //         }}
  //       >
  //         {Object.entries(groupedItems).length === 0 && (
  //           <li style={{ padding: "6px", color: "#888", fontSize: "11px" }}>
  //             No results found
  //           </li>
  //         )}
  //         {Object.entries(groupedItems).map(([category, items]) => (
  //           <React.Fragment key={category}>
  //             <li
  //               style={{
  //                 padding: "6px 8px",
  //                 backgroundColor: "#f5f5f5",
  //                 fontWeight: "bold",
  //                 borderBottom: "1px solid #eee",
  //                 fontSize: "11px",
  //               }}
  //             >
  //               {category}
  //             </li>
  //             {items.map((item) => (
  //               <li
  //                 key={item.path}
  //                 style={{
  //                   padding: "6px 12px",
  //                   cursor: "pointer",
  //                   borderBottom: "1px solid #eee",
  //                   transition: "background-color 0.2s",
  //                   fontSize: "11px",
  //                   lineHeight: "1.4",
  //                 }}
  //                 onMouseDown={() => handleSelect(item)}
  //                 onMouseEnter={(e) =>
  //                   (e.target.style.backgroundColor = "#f0f0f0")
  //                 }
  //                 onMouseLeave={(e) =>
  //                   (e.target.style.backgroundColor = "#fff")
  //                 }
  //               >
  //                 {item.label}
  //               </li>
  //             ))}
  //           </React.Fragment>
  //         ))}
  //       </ul>
  //     )}
  //   </div>
  // );
}

